import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiService, HttpError, TApiFetchResponse } from 'web_core_library';
import { HttpStatusCode } from '../constants';
import LegalsService from '../services/LegalsService';
import { LegalsActions } from './slice';
import { ILegalsRequestPayload } from './types';
import { sortCountries } from './utils';

export function* startFeatureSaga() {
  yield call(LegalsService.init, ApiService);
  try {
    const countriesData: TApiFetchResponse<typeof LegalsService.getCountriesList> = yield call(
      LegalsService.getCountriesList
    );
    const { countries, mostCommon } = sortCountries(countriesData.data);
    yield put(LegalsActions.legalsUpdateCountries(countries, mostCommon));
  } catch (error) {
    console.error('Error fetching countries list:', error);
    yield fork(handleApiError, error as HttpError);
  }
}

export function* requestArticlesSaga(action: PayloadAction<ILegalsRequestPayload>) {
  try {
    const response: TApiFetchResponse<typeof LegalsService.requestTouArticles> = yield call(
      LegalsService.requestTouArticles,
      action.payload.articleAlias,
      action.payload.country,
      action.payload.language
    );
    const articles = response.data.articles;
    yield put(LegalsActions.legalsLoaded(articles));
    return;
  } catch (error) {
    yield fork(handleApiError, error as HttpError);
  }
}

function* handleApiError(response: HttpError) {
  const message =
    response.status === HttpStatusCode.Unauthorized || response.status === HttpStatusCode.TokenExpired
      ? 'common:Errors.SessionExpired'
      : 'common:Errors.System';
  yield put(LegalsActions.legalsFailed(message));
}

export default function* legalsAppRootSaga() {
  yield all([
    takeEvery(LegalsActions.legalsInit, startFeatureSaga),
    takeEvery(LegalsActions.legalsRequest, requestArticlesSaga),
  ]);
}
